<template>
    <div class="AddToHomescreenPopup">
        <div class="image-wrapper">
            <img src="@/assets/images/favicon-32x32.png" alt="memolife-logo" />
        </div>
        <div class="text-wrapper">
            <h5>{{ $t('title') }}</h5>
            <p>{{ $t('paragraph') }}</p>
        </div>
        <div class="buttons-wrapper">
            <button class="button-blue" @click="handleAddingAppToHomepage()">
                {{ $t('buttonText') }}
            </button>
            <button class="hide-popup-btn" @click="$emit('hidePrompt')">
                x
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        defferedPromptEvent: {
            type: Event,
            required: true
        }
    },
    methods: {
        handleAddingAppToHomepage() {
            this.showAddToHomepageInstallBanner();
            this.$emit('hidePrompt');
        },

        showAddToHomepageInstallBanner() {
            this.defferedPromptEvent.prompt();
        }
    }
};
</script>

<translations>
    title: Add Memolife
    title_no: Legg memolife
    paragraph: to Home Screen
    paragraph_no: til startsiden
    buttonText: Add
    buttonText_no: Legg
</translations>

<style lang="scss" scoped>
.AddToHomescreenPopup {
    position: absolute;
    left: 50%;
    top: 10px;
    transform: translateX(-50%);
    background: white;
    display: flex;
    align-items: center;
    border-radius: 3px;
    z-index: 2;

    @media (max-width: 650px) {
        width: 50%;
        display: flex;
        justify-content: space-between;
    }
    @media (max-width: 550px) {
        width: 60%;
    }
    @media (max-width: 450px) {
        width: 70%;
    }
    @media (max-width: 400px) {
        width: 80%;
    }
    .image-wrapper {
        padding: 10px 15px;
    }
    .text-wrapper {
        padding-right: 15px;
        h5,
        p {
            margin: 3px 0;
        }
        p {
            font-size: 12px;
        }
    }
    .buttons-wrapper {
        padding-right: 15px;
        display: flex;
        button {
            border: none;
            font-size: 12px;
            min-width: 4em;
            min-height: 2em;
            cursor: pointer;
        }
        .hide-popup-btn {
            background: white;
            min-width: 2em;
            margin-left: 5px;
        }
    }
}
</style>
